var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { UiIcon, UiSpinner } from '@claims-ia/design-system';
let ReceiptUpload = class ReceiptUpload extends Vue {
    get originalNameOrPreviewText() {
        var _a;
        return ((_a = this.uploadedFile) === null || _a === void 0 ? void 0 : _a.originalName) || this.previewText;
    }
};
ReceiptUpload = __decorate([
    Component({
        components: { UiIcon, UiSpinner },
        props: {
            uploadedFile: {
                type: Object,
                required: false,
            },
            previewText: {
                type: String,
                required: true,
            },
            uploadLabel: {
                type: String,
                required: true,
            },
            isLoading: {
                type: Boolean,
                default: false,
            },
            deletable: {
                type: Boolean,
                default: true,
            },
            disabledIfUploaded: {
                type: Boolean,
                default: true,
            },
        },
    })
], ReceiptUpload);
export default ReceiptUpload;
